import { collection, onSnapshot, query, where } from "firebase/firestore";
import { db } from "../firebase";
import type { CapacityDoc, BusyRange } from "../lib/types";

// capacity/{YYYY-MM-DD}: maintained transactionally by the booking function.
// The customer calendar reads it to disable full-for-this-breed days and
// overlapping time slots without scanning the bookings collection. Public read.

export type CapacityMap = Record<string, CapacityDoc>;

function parseBusy(raw: unknown): BusyRange[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .filter((r): r is BusyRange =>
      !!r && typeof r === "object" &&
      typeof (r as BusyRange).start === "number" && typeof (r as BusyRange).end === "number")
    .map((r) => ({ start: r.start, end: r.end }));
}

// Subscribe to capacity docs in a date range (the visible month plus padding).
// We filter on the stored `date` field (a plain single-field range, no index or
// document-id-reference gymnastics needed).
export function subscribeCapacityRange(
  startYmd: string,
  endYmd: string,
  onData: (map: CapacityMap) => void,
  onError: (e: Error) => void,
): () => void {
  const q = query(
    collection(db, "capacity"),
    where("date", ">=", startYmd),
    where("date", "<=", endYmd),
  );
  return onSnapshot(
    q,
    (snap) => {
      const map: CapacityMap = {};
      for (const d of snap.docs) {
        const r = d.data();
        map[d.id] = {
          counts: (r.counts && typeof r.counts === "object" ? r.counts : {}) as Record<string, number>,
          busy: parseBusy(r.busy),
        };
      }
      onData(map);
    },
    (err) => onError(err),
  );
}
